import urlencode from 'urlencode'

import externalValuesToOrderEntryValues from './externalValuesToOrderEntryValues'

/**
 * Get OrderEntry values from URL params
 * @param searchQuery Usually just window.location.search
 * @returns
 */
export default function getUrlParamValues(searchQuery: string): object | null {
  const paramName = 'initial_values'
  const urlParams = new URLSearchParams(searchQuery)
  const initialUrlValuesString = urlParams.get(paramName)
  const json = urlencode.decode(initialUrlValuesString)
  const data = JSON.parse(json)

  if (!data) {
    return null
  }

  return externalValuesToOrderEntryValues(data)
}
